import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationJobProducedPluginService extends InspectionPluginService {
  private labelValuesKeys: any = [
    { value: 1, label: 'plugins.installationjobproduced.number-of-blanks' },
    { value: 2, label: 'plugins.installationjobproduced.cutting-stamping-strength' },
    { value: 3, label: 'plugins.installationjobproduced.job-length' },
    { value: 4, label: 'plugins.installationjobproduced.board-type' },
    { value: 5, label: 'plugins.installationjobproduced.number-of-color' },
    { value: 6, label: 'plugins.installationjobproduced.box-type' }
  ];

  private labelValues: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public applyTranslations() {
    this.labelValues = [];
    this.copyTranslationValues(this.labelValuesKeys, this.labelValues, this.language);
  }

  public getLabelValues() {
    return this.labelValues;
  }

  public updateJobProduced(inspectionId: string, pointId: string, pluginId: string, jobProduced: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, jobProduced).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, jobProduced: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, jobProduced, 'JobProduced').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
